import { IncomingMessage } from 'http';
import { safeSplit } from '../util/arrays/safeSplit';
import { BrowserService } from './BrowserService';
import { Public } from './Public.type';
import { useServices } from './Services';
import { SsrData } from './SsrData';

export const makeHostName = (
  ssrData: SsrData,
  browser: Public<BrowserService>,
  req?: IncomingMessage,
) => {
  const slot = ssrData.slot('HOST_NAME', () => ({ value: '' }));

  if (req) {
    const hostWithPort = String(req.headers['x-forwarded-host'] ?? req.headers.host ?? '');
    slot.value = safeSplit(hostWithPort, ':')[0];
  } else if (browser.window?.location?.hostname) {
    slot.value = browser.window.location.hostname;
  }

  return slot.value;
};

export const useHostName = () => useServices().hostName;
